module.exports = __webpack_public_path__ + "img/introduce-sentosa.beceb35c.svg";